import React from "react";

import Cat5eImg from '../../../../assets/images/cat5e.png';

import './styles.css';
import "font-awesome/css/font-awesome.min.css";

const Cat5e = () => {

    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>Cat5e (Categoria 5e)</h1>
                </div>
                <div className="col-sm-12">
                    <div className="siglas">
                        <img src={Cat5eImg} alt="siglas" />
                    </div>
                </div>                
            </div>
        </div>
    );
};
export default Cat5e;